export interface ItemLinkConfig {
	urlField: string; // Item field to add to url
	urlPrefix: string; // Navigation route prefix
}
